module.exports = __webpack_public_path__ + "ecfe41c850f03d8053b386d273642a73.jpg";